import * as React from "react";

const SvgMultipleItems = () => (
  <svg
    width="1.55em"
    height="1em"
    viewBox="0 0 142 92"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="42" height="42" rx="5.56298" fill="#3B3B3C" />
    <rect x="50" width="42" height="42" rx="5.56298" fill="#3B3B3C" />
    <rect x="100" width="42" height="42" rx="5.56298" fill="#B8B8B8" />
    <rect y="50" width="42" height="42" rx="5.56298" fill="#B8B8B8" />
    <rect x="50" y="50" width="42" height="42" rx="5.56298" fill="#5AA3FF" />
    <rect x="100" y="50" width="42" height="42" rx="5.56298" fill="#B8B8B8" />
  </svg>
);
export default SvgMultipleItems;
